export { default } from './CategoryTile';
